import React from 'react';
import classNameBind from 'classnames/bind';
import Label from '../Label';
import styles from './Menu.module.css';
import MenuElement from './components/MenuElement';

const bindClasses = classNameBind.bind(styles);

const Menu = ({ items, onSelect, selected }) => {
  const allItems = items.reduce((acc, curr) => (acc.concat(curr.sectionItems)), []);
  const selectedItem = allItems.find(
    sectionItem => (sectionItem.id === selected),
  );
  let selectedContent = null;
  if (selectedItem) {
    selectedContent = selectedItem.content;
  }

  return (
    <div
      className={bindClasses('container')}
      data-ppuc-id="Menu"
    >
      <div className={bindClasses('left-section')}>
        {items.map(sections => (
          <div
            className={bindClasses('section')}
            key={sections.section}
          >
            {sections.section && (
              <div className={bindClasses('section-ctn')}>
                <Label type="section">{sections.section}</Label>
              </div>
            )}
            {sections.sectionItems.map(sectionItem => (
              <MenuElement
                data={sectionItem}
                onSelect={onSelect}
                active={selected === sectionItem.id}
                key={sectionItem.id}
              />
            ))}
          </div>
        ))}
      </div>
      <div className={bindClasses('right-section')}>
        {selectedContent}
      </div>
    </div>
  );
};

Menu.defaultProps = {
  selected: '',
};

export default Menu;
